(() => {
  const loader = document.querySelector('[data-ppl-typography-loader]');
  if (!loader) return;
  const protectedSelector = '.pw-buy-box,[data-pw-id="buy-box"],cart-drawer,cart-notification,.drawer,.cart-drawer,[data-pw-id="sticky"],.pw-sticky-cart,.sticky-atc';
  const excludedSelector = 'script,style,noscript,option,svg,video,audio,iframe';
  const rootSelector = 'main,.topbar,[data-ppl-header],.site-footer';
  const numeric = value => Number.parseFloat(value) || 0;
  let pending = false;
  function applyTypography() {
    pending = false;
    document.querySelectorAll('[data-ppl-text]').forEach(el => {
      el.removeAttribute('data-ppl-text');
      el.style.removeProperty('--ppl-label-size');
    });
    const updates = [];
    const elements = new Set();
    document.querySelectorAll(rootSelector).forEach(root => {
      elements.add(root);
      root.querySelectorAll('*').forEach(el => elements.add(el));
    });
    elements.forEach(el => {
      if (el.closest(protectedSelector) || el.closest(excludedSelector)) return;
      const direct = Array.from(el.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent.trim()).join(' ').trim();
      if (!direct || /^[+×↑↓→←↗★✿✓ⓘ↻|♡]+$/.test(direct)) return;
      const heading = el.closest('h1,h2,h3,h4');
      let role = 'label';
      if (heading) role = heading.tagName.toLowerCase();
      else if (el.matches('p,blockquote') && !el.matches('[class*="note"],[class*="fine"],[class*="source"],[class*="eyebrow"],[class*="label"]') && el.textContent.trim().length > 65) role = 'body';
      else if (el.closest('.ingredient-back') && direct.length > 85 && !el.matches('small')) role = 'body';
      const sourceSize = numeric(getComputedStyle(el).fontSize);
      if (role === 'label' && sourceSize >= 28) role = 'stat';
      updates.push({ el, role, size: Math.max(16, sourceSize) });
    });
    document.documentElement.dataset.pplTypography = loader.dataset.pplPage;
    updates.forEach(({ el, role, size }) => {
      el.dataset.pplText = role;
      if (role === 'label' || role === 'stat') el.style.setProperty('--ppl-label-size', `${size}px`);
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(applyTypography); }
  }
  applyTypography();
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
